import { Component, Input } from '@angular/core';
import { AppearanceSettings } from '../../services/appearance/appearance';

/** Layout placeholders share the profile's banner and responsive column sizes. */
@Component({selector: 'app-profile-skeleton', templateUrl: './profile-skeleton.component.html', styleUrls: ['./profile-skeleton.component.scss']})
export class ProfileSkeletonComponent {
    @Input() variant: 'page' | 'content' | 'activity' = 'page';
    @Input() name = '';
    @Input() description = '';
    @Input() appearance: AppearanceSettings;
    @Input() resolvedDisplay = false;
    @Input() avatarMediaId: number;
    @Input() bannerMediaId: number;
    readonly rows = [0, 1, 2];
}
